import React from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

export default function InfoTip({ text }) {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" data-testid="info-tip" className="inline-flex items-center justify-center w-4 h-4 rounded-full text-zinc-400 hover:text-[#0A0A0A] transition-colors align-middle ml-1">
            <Info className="w-3.5 h-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-[240px] text-xs leading-relaxed bg-zinc-900 text-white">
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
